// src/components/remediationScorecardNav.js

/**
 * The Remediations nav entry. When the scorecard is available to this user it becomes a parent
 * with two children, Remediations and Scorecard; otherwise it is the plain Remediations link.
 */
export const remediationsNavItem = (scorecardEnabled, { remediationsIcon, scorecardIcon }) => {
  const item = { path: "/remediations", label: "Remediations", icon: remediationsIcon };
  if (!scorecardEnabled) return item;
  return {
    ...item,
    children: [
      { path: "/remediations", label: "Remediations", icon: remediationsIcon },
      { path: "/remediation-scorecard", label: "Scorecard", icon: scorecardIcon },
    ],
  };
};

/**
 * Frontend mirror of the API's CanAccessOrganization, shared by the route guard and the nav entry.
 * canViewOrganization covers ORG, DEAL, BU and SELF members. The admin flags are checked as well
 * because the backend treats them as authoritative, while canViewOrganization only sees admins
 * through their expanded synthetic roles.
 */
export const canAccessScorecard = ({ isSuperAdmin, isSupportAdmin, canViewOrganization }) =>
  isSuperAdmin() || isSupportAdmin() || canViewOrganization();
